import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  position: relative;
  overflow: hidden;
  padding: 0 15px;
  min-height: 100vh;
  display: grid;
  align-items: center;
  background: #272742;
`;
const SkewedPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100vw;
  height: 150vh;
  overflow: hidden;
  transform: skewY(-45deg);
  transform-origin: 100%;
  background: rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 0;
`;

const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
`;

const Section = styled.div`
  display: grid;
  width: 100%;
  overflow: hidden;
  color: #fff;
  grid-template-areas:
    'title'
    'tabs'
    'images'
    'cta';
  padding: 20px 0;
  @media (min-width: 768px) {
    grid-template-rows: 0.25fr 1fr 0.1fr;
    align-items: start;
    grid-column-gap: 100px;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'title images'
      'tabs images'
      'cta images';
    padding: 0;
  }
  Button {
    position: relative;
    z-index: 1;
    margin: 15px 0;
    grid-area: cta;
    border-radius: 20px;
    padding: 7.5px 15px;
    background: #000;
    color: ${COLORS.WHITE};
    font-weight: bold;
    :hover {
      background: #000;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }
`;

const Title = styled.div`
  grid-area: title;
  font-size: 40px;
  line-height: 50px;
  margin-top: 0;
  font-weight: bold;
  margin-bottom: 20px;
  @media (max-width: 767.9px) {
    font-size: 30px;
    line-height: 40px;
  }
`;

const Tabs = styled.ul`
  position: relative;
  text-align: left;
  padding: 0;
  margin: 0;
  grid-area: tabs;

  li.active {
    background-color: rgba(86, 86, 146, 0.5);
    opacity: 1;
    p {
      color: #000;
    }
  }
  li {
    position: relative;
    outline: 0 !important;
    width: 100%;
    height: auto;
    border-radius: 0;
    color: #fff;
    display: grid;
    margin: 0.5em 0;
    align-items: start;
    padding: 1em;
    border-radius: 4px;
    background: #000;
    opacity: 0.2;
    cursor: pointer;
    &:last-child img {
      top: 0;
    }
    h3 {
      margin: 0;
      font-size: 24px;
      line-height: 36px;
      @media (min-width: 767.9px) {
        font-size: 20px;
        line-height: 18px;
      }
    }
    p {
      margin: 0;
      font-size: 15px;
      line-height: 2;
      @media (min-width: 767.9px) {
        font-size: 14px;
      }
    }
    img {
      position: absolute;
      right: -99px;
      top: 37px;
    }
  }
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
`;
const DisplaySection = styled.div`
  grid-area: images;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  max-width: 100%;
  img {
    height: 100%;
    object-fit: contain;
  }
`;

const Description = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
  flex-direction: column;
  p {
    font-size: 15px;
    margin-top: 0;
    @media (min-width: 1024px) {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;

export {
  Container,
  SkewedPanel,
  Section,
  Wrapper,
  Title,
  Tabs,
  DisplaySection,
  Description,
};
